import * as ReselectModule from "reselect";
import { IActionListState } from ".";
import { IApplicationState } from "..";

export const selectActionList: ReselectModule.Selector<
  IApplicationState,
  IActionListState
> = (state) => state.actionList;
